/* eslint-disable complexity, guard-for-in, max-lines, max-lines-per-function */
/* eslint-disable max-statements, no-negated-condition, vars-on-top */
/* eslint-disable jsdoc/require-param, jsdoc/require-returns */
/* eslint-env jquery */

export class GazeboBuilder {
    /**
     * Constructor.
     *
     * @param {NodeList} node The node to setup the builder on.
     */
    constructor(node) {
        // Disable auto scroll to anchor.
        setTimeout(() => {
            if (location.hash) {
                window.scrollTo(0, 0);
            }
        }, 1);

        this.target = node;

        this.o = {
            integrated: true,
            stepsVersion: 0,
            optionsVersion: 0,
            renderVersion: 0,
            thumbnailVersion: 116,
            quotingMode: false,
            editingMode: false,
            urlBase: '',
            topOffset: '',
            optionTabs: '.gb-option-tabs',
            optionMobileTabs: '.gb-mobile-menu-select',
            optionFields: '.gb-option-fields',
            prevNextContainer: '.gb-prev-next-container',
            loadingImg: '.gb-loading',
            estimateContainer: '.gb-estimate-container',
            estimate: '.gb-estimate',
            summary: '.gb-summary',
            userProfile: {},
            conf: {},
        };

        // HTML5 data- support.
        for (const i in this.o) {
            const key = `gazeboBuilder${i.charAt(0).toUpperCase()}${i.slice(
                1
            )}`;
            if (typeof $(this.target).data(key) !== 'undefined') {
                this.o[i] = $(this.target).data(key);
            }
        }

        this.stepId = 1;
        if (
            window.location.hash &&
            window.location.hash.substr(0, 9) === '#gb-step-'
        ) {
            this.stepId = window.location.hash.substr(9);

            if (this.isNumeric(this.stepId) === true) {
                this.stepId = Number(this.stepId);
            }
        }

        this.confId = '';
        this.conf = {};
        this.imgObj = false;
        this.quotingMode = $(this.o.quotingMode);
        this.editingMode = $(this.o.editingMode);
        this.tabContainer = $(this.o.optionTabs);
        this.mobileTabContainer = $(this.o.optionMobileTabs);
        this.fieldContainer = $(this.o.optionFields);
        this.prevNextContainer = $(this.o.prevNextContainer);
        this.imgContainer = $(`#${this.target.id}`);
        this.loadingImg = $(this.o.loadingImg);
        this.estimateContainer = $(this.o.estimateContainer);
        this.estimate = $(this.o.estimate);
        this.summary = $(this.o.summary);
        this.bg = $(`#${this.target.id}`).find('.gb-preview-bg');
        this.img = $(`#${this.target.id}`).find('.gb-preview-image');
        this.buildSteps = {};
        this.buildOptions = {};
        this.prevNextWrapper = $('<div class="gb-prev-next-wrapper"></div>');

        let stepsJsonFilename = 'steps-request.json';
        const optionsJsonFilename = 'options.json';
        if (this.o.quotingMode) {
            stepsJsonFilename = 'steps.json';
            // optionsJsonFilename = 'options-quoting.json';
        }

        const confDir = `${this.o.urlBase}/gazebo_builder_assets/conf/`;

        const stepsJson = `${confDir}${stepsJsonFilename}?v=${this.o.stepsVersion}`;

        const optionsJson = `${confDir}${optionsJsonFilename}?v=${this.o.optionsVersion}`;

        this.prevNextContainer.append(this.prevNextWrapper);

        const requestBuildSteps = new XMLHttpRequest();
        requestBuildSteps.open('GET', stepsJson, true);
        requestBuildSteps.onload = () => {
            if (
                requestBuildSteps.readyState === 4 &&
                requestBuildSteps.status === 200
            ) {
                this.buildSteps = JSON.parse(requestBuildSteps.responseText);

                const requestBuildOptions = new XMLHttpRequest();
                requestBuildOptions.open('GET', optionsJson, true);
                requestBuildOptions.onload = () => {
                    if (
                        requestBuildOptions.readyState === 4 &&
                        requestBuildOptions.status === 200
                    ) {
                        this.buildOptions = JSON.parse(
                            requestBuildOptions.responseText
                        );

                        // Remove quoting only sizes and structures.
                        if (!this.o.quotingMode) {
                            delete this.buildOptions[
                                'gazebo--rectangle--wood--ft8x10'
                            ];
                            delete this.buildOptions[
                                'gazebo--rectangle--wood--ft8x14'
                            ];
                            delete this.buildOptions[
                                'gazebo--rectangle--wood--ft14x16'
                            ];
                            delete this.buildOptions[
                                'gazebo--rectangle--vinyl--ft8x10'
                            ];
                            delete this.buildOptions[
                                'gazebo--rectangle--vinyl--ft8x14'
                            ];
                            delete this.buildOptions[
                                'gazebo--rectangle--vinyl--ft14x16'
                            ];

                            delete this.buildOptions[
                                'gazebo--octagon--wood--ft6'
                            ];
                            delete this.buildOptions[
                                'gazebo--octagon--vinyl--ft6'
                            ];

                            delete this.buildOptions[
                                'pergola--traditional--wood--ft12x24'
                            ];
                            delete this.buildOptions[
                                'pergola--traditional--wood--ft16x32'
                            ];
                            delete this.buildOptions[
                                'pergola--traditional--vinyl--ft12x24'
                            ];
                            delete this.buildOptions[
                                'pergola--traditional--vinyl--ft16x32'
                            ];

                            delete this.buildOptions[
                                'pergola--artisan--wood--ft12x24'
                            ];
                            delete this.buildOptions[
                                'pergola--artisan--wood--ft16x32'
                            ];
                            delete this.buildOptions[
                                'pergola--artisan--vinyl--ft12x24'
                            ];
                            delete this.buildOptions[
                                'pergola--artisan--vinyl--ft16x32'
                            ];

                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x10'
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x12 '
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x14'
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x16'
                            ];

                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x20'
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x24'
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x28'
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x32'
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x36'
                            ];
                            delete this.buildOptions[
                                'pavilion--alpine--wood--ft20x40'
                            ];

                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft12x18'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft12x20'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft12x22'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft12x24'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft14x18'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft14x20'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft14x22'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--vinyl--ft14x24'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft12x18'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft12x20'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft12x22'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft12x24'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft14x18'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft14x20'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft14x22'
                            ];
                            delete this.buildOptions[
                                'pavilion--grand_estate--wood--ft14x24'
                            ];

                            this.deleteFromObject(
                                'pavilion--santa_fe--wood',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pavilion--santa_fe--vinyl',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pavilion--santa_fe_cedar--wood',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pergola--santa_fe--wood',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pergola--santa_fe--vinyl',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pergola--santa_fe_cedar--wood',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pergola--hearthside--wood',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pergola--kingston--wood',
                                this.buildOptions
                            );
                            this.deleteFromObject(
                                'pergola--arcadian--vinyl',
                                this.buildOptions
                            );
                        }

                        this.refreshConfId();
                        this.refreshConf();
                        this.changeStructure();
                        if (this.o.quotingMode) {
                            this.changeStep(this.stepId);
                        }
                        this.changeSize();
                        this.refreshWidthLength();
                        this.refreshImg();
                        this.refreshSummary();
                        this.replaceHistoryState();
                    } else {
                        // We reached our target server, but it returned an error
                    }
                };
                requestBuildOptions.onerror = () => {
                    // There was a connection error of some sort
                };
                requestBuildOptions.send();
            } else {
                // We reached our target server, but it returned an error
            }
        };
        requestBuildSteps.onerror = () => {
            // There was a connection error of some sort
        };
        requestBuildSteps.send();
    }

    /**
     * Check if a variable is numeric.
     */
    isNumeric(num) {
        return !isNaN(parseFloat(num)) && isFinite(num);
    }

    /**
     * Delete properties from an object that match a pattern.
     */
    deleteFromObject(keyToDelete, obj) {
        for (const k in obj) {
            // If the current key contains the string
            // we're looking for delete it.
            if (k.indexOf(keyToDelete) !== -1) {
                delete obj[k];
            }
        }
    }

    /**
     * Generate the current configurations unique id for it's
     * entry in the this.buildOptions array.
     */
    refreshConfId() {
        const conf = this.o.conf;

        this.confId = `${conf.structure}--${conf.style}--${conf.material}--${conf.size}`;
    }

    /**
     * Store a copy of the current configurations
     * this.buildOptions array entry.
     */
    refreshConf() {
        // If the configuration exists use it.
        const conf = this.buildOptions[this.confId];
        if (typeof conf !== 'undefined') {
            this.conf = conf;
            return;
        }

        // If the configuration is invalid try all the sizes.
        let size;
        const sizes =
            typeof this.buildSteps[this.o.conf.structure].steps[2].attrs
                .size !== 'undefined'
                ? this.buildSteps[this.o.conf.structure].steps[2].attrs.size
                      .options
                : { ftn_a: 'NA' };
        for (size in sizes) {
            if (this.confExists('size', size)) {
                this.o.conf.size = size;
                this.refreshConfId();
                this.conf = this.buildOptions[this.confId];
                return;
            }
        }

        // If the configuration is invalid try all the styles.
        let style;
        const styles = this.buildSteps[this.o.conf.structure].steps[1].attrs
            .style.options;
        for (style in styles) {
            if (this.confExists('style', style)) {
                this.o.conf.style = style;
                this.refreshConfId();
                this.conf = this.buildOptions[this.confId];
                return;
            }
        }

        // If the configuration is invalid try all the materials.
        let material;
        const materials = this.buildSteps[this.o.conf.structure].steps[1].attrs
            .material.options;
        for (material in materials) {
            if (this.confExists('material', material)) {
                this.o.conf.material = material;
                this.refreshConfId();
                this.conf = this.buildOptions[this.confId];
                return;
            }
        }

        // If the configuration is still invalid after trying different
        // materials and sizes independantly go through each material/size
        // combination and find the first valid one.
        for (size in sizes) {
            for (style in styles) {
                for (material in materials) {
                    if (
                        this.confExists(
                            'material',
                            material,
                            'size',
                            size,
                            'style',
                            style
                        )
                    ) {
                        this.o.conf.material = material;
                        this.o.conf.size = size;
                        this.o.conf.style = style;
                        this.refreshConfId();
                        this.conf = this.buildOptions[this.confId];
                        return;
                    }
                }
            }
        }
    }

    /**
     * Get the value of a current configuration's attribute.
     */
    getConfValue(attr) {
        // Make sure the attribute exists.
        if (typeof this.o.conf[attr] === 'undefined') {
            return false;
        }

        return this.o.conf[attr];
    }

    /**
     * Check an attribute or attribute option to see if
     * it's availability requirements are set.
     */
    requiredIsSatisfied(attrConf) {
        if (
            typeof attrConf.required === 'undefined' &&
            typeof attrConf.required_qty_or === 'undefined'
        ) {
            return true;
        }

        if (typeof attrConf.required !== 'undefined') {
            for (const requiredAttr in attrConf.required) {
                const requireOptions = attrConf.required[requiredAttr];
                const val = this.getConfValue(requiredAttr);
                if (requireOptions.indexOf(val) === -1) {
                    return false;
                }
            }
        }

        if (typeof attrConf.required_qty_or !== 'undefined') {
            let hadOne = false;

            attrConf.required_qty_or.forEach((requiredQtyAttr) => {
                const requiredQtyAttrVal = this.getConfValue(requiredQtyAttr);
                if (Number(requiredQtyAttrVal) !== 0) {
                    hadOne = true;
                }
            });

            return hadOne;
        }

        return true;
    }

    /**
     * Check whether or not the current configuration allows
     * for the specified attribute's specified option to be made available.
     */
    optionIsAvailable(stepId, attr, option) {
        // Make sure the option is available with the base configuration.
        let optionId = attr;
        if (typeof option !== 'undefined' && option) {
            optionId += `__${option}`;
        }

        // Make sure the option is available with the base configuration.
        if (
            attr.substr(0, 29) !== 'repeat_higher_post_increments' &&
            attr.substr(0, 35) !== 'repeat_higher_post_increments_label'
        ) {
            if (
                typeof this.conf[optionId] === 'undefined' ||
                this.conf[optionId] === 'NA'
            ) {
                return false;
            }
        }

        const attrConf = this.getAttrConf(this.o.conf.structure, stepId, attr);

        // Make sure that all requirements for the attribute are met.
        if (this.requiredIsSatisfied(attrConf) === false) {
            return false;
        }

        // Make sure that all requirements for the option are met.
        if (
            typeof attrConf.options !== 'undefined' &&
            typeof attrConf.options[option] !== 'undefined' &&
            this.requiredIsSatisfied(attrConf.options[option]) === false
        ) {
            return false;
        }

        return true;
    }

    /**
     * Get the name of the option based on the configuration.
     */
    getOptionName(attrs, option) {
        if (typeof attrs.options[option] === 'undefined') {
            return '';
        }

        if (
            this.o.conf.material === 'vinyl' &&
            typeof attrs.options[option].name_vinyl !== 'undefined'
        ) {
            return attrs.options[option].name_vinyl;
        }

        if (typeof attrs.options[option].name !== 'undefined') {
            return attrs.options[option].name;
        }

        return '';
    }

    /**
     * Get the price for the specified attribute's specified option.
     */
    getBaseOptionPrice(attr, option) {
        let optionId = attr;
        if (typeof option !== 'undefined' && option) {
            optionId += `__${option}`;
        }

        if (optionId === 'higher_post_increments') {
            const higherPosts = this.getConfValue('higher_post_increments');
            if (higherPosts) {
                optionId = `${optionId}_cost_${higherPosts}`;
            }
        }

        // Make sure the option is available with the base configuration.
        if (
            typeof this.conf[optionId] === 'undefined' ||
            this.conf[optionId] === 'NA'
        ) {
            return 0;
        }

        // If additional posts have been added and an attribute has an
        // additional post option add it's value to the price.
        const additionalPosts = this.getConfValue('additional_posts');
        if (additionalPosts) {
            const additionalPostOptionId = `posts_added_${additionalPosts}__${optionId}`;
            if (typeof this.conf[additionalPostOptionId] !== 'undefined') {
                // console.log(additionalPostOptionId);
                // console.log(this.conf[additionalPostOptionId]);
                return this.conf[optionId] + this.conf[additionalPostOptionId];
            }
        }

        return this.conf[optionId];
    }

    /**
     * Get the marked up price for the specified attribute's specified option.
     */
    getOptionPrice(attr, option) {
        let price = this.getBaseOptionPrice(attr, option);

        let optionId = attr;
        if (typeof option !== 'undefined' && option) {
            optionId += `__${option}`;
        }

        let colorPercent;
        let colorMarkup;

        // Color Price & Markup.
        if (
            optionId === 'material_finish__stained' ||
            optionId === 'material_finish__painted' ||
            optionId === 'material_color__v1' ||
            optionId === 'material_color__v2' ||
            optionId === 'material_color__v3' ||
            optionId === 'painted_ceiling__p1' ||
            optionId === 'painted_ceiling__p2'
        ) {
            colorPercent = this.conf[optionId];
            colorMarkup = this.o.userProfile[
                `${this.o.conf.structure}_color_modify_percentage`
            ];
            colorPercent += colorMarkup;

            price = this.getMaterialPrice();
            price *= colorPercent / 100;
            price = Math.round(price * 100) / 100;

            return price;
        }

        // Some attributes cost additional money when they are purchased
        // along with a Pagoda roof.
        if (this.o.conf.roof_style === 'pagoda') {
            switch (optionId) {
                case 'roof_material__metal_regular_ribbed':
                case 'roof_material__metal_standing_seam':
                    if (
                        typeof this.buildOptions[this.confId]
                            .pagoda_markup__metal_roofing !== 'undefined' &&
                        this.buildOptions[this.confId]
                            .pagoda_markup__metal_roofing
                    ) {
                        price *=
                            1 +
                            this.buildOptions[this.confId]
                                .pagoda_markup__metal_roofing /
                                100;
                    }
                    break;
                case 'build_to_engineered_specs__yes':
                    if (
                        typeof this.buildOptions[this.confId]
                            .pagoda_markup__build_to_engineered_specs !==
                            'undefined' &&
                        this.buildOptions[this.confId]
                            .pagoda_markup__build_to_engineered_specs
                    ) {
                        price *=
                            1 +
                            this.buildOptions[this.confId]
                                .pagoda_markup__build_to_engineered_specs /
                                100;
                    }
                    break;
                case 'vinyl_soffit__yes':
                    if (
                        typeof this.buildOptions[this.confId]
                            .pagoda_markup__vinyl_soffit !== 'undefined' &&
                        this.buildOptions[this.confId]
                            .pagoda_markup__vinyl_soffit
                    ) {
                        price *=
                            1 +
                            this.buildOptions[this.confId]
                                .pagoda_markup__vinyl_soffit /
                                100;
                    }
                    break;
                default:
                    break;
            }
        }

        switch (optionId) {
            // Some attributes are for values that need applied to the whole
            // build instead of just the option.  We should treat them as $0
            // at the per option level and calculate their values differently
            // later.
            case 'kit_setup__yes':
            case 'kit_setup_percentage':
                price = 0;
                break;
            // Some attributes allow entering a price in manually. This
            // works like a normal quantity field, but we need to specify
            // 1 as the price here so that quantity calculation treats each
            // qty as a dollar.
            case 'engineers_seal_price':
                price = 1;
                break;
            default:
                break;
        }

        price = this.markup(
            this.o.conf.structure,
            'accessories',
            attr,
            option,
            price
        );

        return price;
    }

    /**
     * Get the material price.  This price is used in color price calculations.
     */
    getMaterialPrice() {
        let price = 0;

        // Start with base price.
        const basePrice = this.getBasePrice();
        price += basePrice;

        // Add shape style prices.
        const shapeStylePrice = this.getOptionPrice(
            'shape_style',
            this.o.conf.shape_style
        );
        price += shapeStylePrice;

        // Add victorian braces prices.
        const victorianBracesPrice = this.getOptionPrice(
            'victorian_braces',
            this.o.conf.victorian_braces
        );
        price += victorianBracesPrice;

        // Add turned posts prices.
        const turnedPostsPrice = this.getOptionPrice(
            'turned_posts',
            this.o.conf.turned_posts
        );
        price += turnedPostsPrice;

        // Add benches prices.
        // This item is handled differently because of needing to
        // be based on a qty selection.
        const benchesPrice = this.getOptionPrice('benches');
        if (this.isNumeric(this.o.conf['benches'])) {
            price += benchesPrice * Number(this.o.conf['benches']);
        }

        // Add flooring prices.
        // Only a negative flooring value is taken into account.
        const flooringPrice = this.getOptionPrice(
            'flooring',
            this.o.conf.flooring
        );
        if (flooringPrice < 0) {
            price += flooringPrice;
        }

        // Add no bottom rails prices.
        const noBottomRailsPrice = this.getOptionPrice(
            'no_bottom_rails',
            this.o.conf.no_bottom_rails
        );
        price += noBottomRailsPrice;

        // Add post prices.
        const postPrice = this.getOptionPrice('posts', this.o.conf.posts);
        price += postPrice;

        // Add cupola prices.
        const cupolaPrice = this.getOptionPrice('cupola', this.o.conf.cupola);
        price += cupolaPrice;

        // Add lattice roof prices.
        const latticeRoofPrice = this.getOptionPrice(
            'lattice_roof',
            this.o.conf.lattice_roof
        );
        price += latticeRoofPrice;

        // Add pagoda roof prices.
        if (this.o.conf.roof_style === 'pagoda') {
            const pagodaRoofPrice = this.getOptionPrice(
                'roof_style',
                this.o.conf.roof_style
            );
            price += pagodaRoofPrice;
        }

        $('.quote-table__cell--affects-stain').each((index, element) => {
            const stainItemPriceString = $(element).text();
            const stainItemPrice = Number(
                stainItemPriceString.replace(/[^0-9.-]+/g, '')
            );

            price += stainItemPrice;
        });

        return price;
    }

    /**
     * Get the base price for the current configuration.
     */
    getBasePrice() {
        let price = this.conf.base_price;

        price = this.markup(
            this.o.conf.structure,
            'base',
            'base',
            'base',
            price
        );

        return price;
    }

    markup(structure, category, attr, option, basePrice) {
        const noDeductionMarkup = this.o.userProfile[
            `${structure}_deductible_accessories`
        ];
        let markupType = this.o.userProfile[
            `${structure}_${category}_markup_type`
        ];
        let markupPercentage = this.o.userProfile[
            `${structure}_${category}_markup_percentage`
        ];
        let markupDollar = this.o.userProfile[
            `${structure}_${category}_markup_dollar`
        ];
        let markupRound = this.o.userProfile[
            `${structure}_${category}_markup_round`
        ];

        switch (attr) {
            // Use base markup values for shape style.
            case 'shape_style':
                markupType = this.o.userProfile[
                    `${structure}_base_markup_type`
                ];
                markupPercentage = this.o.userProfile[
                    `${structure}_base_markup_percentage`
                ];
                markupDollar = this.o.userProfile[
                    `${structure}_base_markup_dollar`
                ];
                markupRound = this.o.userProfile[
                    `${structure}_base_markup_round`
                ];
                break;
            // Use EZ shade worksheet values for EZ shade add-ons.
            case 'curtain_size_patterned_8':
            case 'curtain_size_patterned_10':
            case 'curtain_size_patterned_12':
            case 'curtain_size_patterned_14':
            case 'curtain_size_patterned_16':
            case 'curtain_size_patterned_18':
            case 'curtain_size_solid_8':
            case 'curtain_size_solid_10':
            case 'curtain_size_solid_12':
            case 'curtain_size_solid_14':
            case 'curtain_size_solid_16':
            case 'curtain_size_solid_18':
            case 'canopy_size_8x8':
            case 'canopy_size_8x10':
            case 'canopy_size_8x12':
            case 'canopy_size_8x14':
            case 'canopy_size_8x16':
            case 'canopy_size_8x20':
            case 'canopy_size_8x24':
            case 'canopy_size_10x8':
            case 'canopy_size_10x10':
            case 'canopy_size_10x12':
            case 'canopy_size_10x14':
            case 'canopy_size_10x16':
            case 'canopy_size_10x20':
            case 'canopy_size_10x24':
            case 'canopy_size_12x8':
            case 'canopy_size_12x10':
            case 'canopy_size_12x12':
            case 'canopy_size_12x14':
            case 'canopy_size_12x16':
            case 'canopy_size_12x20':
            case 'canopy_size_12x24':
            case 'canopy_size_14x8':
            case 'canopy_size_14x10':
            case 'canopy_size_14x12':
            case 'canopy_size_14x14':
            case 'canopy_size_14x16':
            case 'canopy_size_14x20':
            case 'canopy_size_14x24':
            case 'canopy_size_16x8':
            case 'canopy_size_16x10':
            case 'canopy_size_16x12':
            case 'canopy_size_16x14':
            case 'canopy_size_16x16':
            case 'canopy_size_16x20':
            case 'canopy_size_16x24':
                markupType = this.o.userProfile[
                    `e_z_shade_only_accessories_markup_type`
                ];
                markupPercentage = this.o.userProfile[
                    `e_z_shade_only_accessories_markup_percentage`
                ];
                markupDollar = this.o.userProfile[
                    `e_z_shade_only_accessories_markup_dollar`
                ];
                markupRound = this.o.userProfile[
                    `e_z_shade_only_accessories_markup_round`
                ];
                break;
            default:
                break;
        }

        // Don't calculate any base price markups
        // for an EZ-shade only structures.
        if (structure === 'e_z_shade_only') {
            if (
                attr === 'base' ||
                attr === 'structure' ||
                attr === 'material' ||
                attr === 'style'
            ) {
                return basePrice;
            }
        }

        // Don't markup seal price.
        if (attr === 'engineers_seal_price') {
            return basePrice;
        }

        // If the deductible_accessories option is disabled don't change how
        // much is deducted for deductable option.
        if (
            !noDeductionMarkup &&
            ((attr === 'roof_material' && option === 'no_shingles') ||
                (attr === 'flooring' && option === 'none') ||
                (attr === 'no_bottom_rails' && option === 'yes') ||
                attr === 'attach_to_house')
        ) {
            return basePrice;
        }

        let markupPrice = basePrice;

        // Add any percent base increases.
        // These can be either be markup or a gross margin
        // depending on the selected value for markupType.
        if (markupPercentage) {
            if (markupType === 1) {
                // Mark-up
                markupPrice *= 1 + markupPercentage / 100;
            } else if (markupType === 2) {
                // Gross Margin
                markupPrice /= 1 - markupPercentage / 100;
            }
        }

        // Add any fixed dollar amount increases.
        if (markupDollar) {
            markupPrice += markupDollar;
        }

        // Round the marked up price.
        switch (markupRound.toString()) {
            case '0.01':
                markupPrice = Math.round(markupPrice * 100) / 100;
                break;
            case '0.1':
                markupPrice = Math.round(markupPrice * 10) / 10;
                break;
            case '1':
                markupPrice = Math.round(markupPrice);
                break;
            case '5':
                markupPrice = Math.round(markupPrice / 5) * 5;
                break;
            case '10':
                markupPrice = Math.round(markupPrice / 10) * 10;
                break;
            default:
                // Do nothing
                break;
        }

        return markupPrice;
    }

    getAttrConf(structure, stepId, attr) {
        if (attr.substr(0, 28) === 'higher_post_increments_label') {
            return {
                text: true,
                required: {
                    higher_post: ['yes'],
                },
                name: 'All Posts Additional Height',
            };
        }

        if (attr.substr(0, 35) === 'repeat_higher_post_increments_label') {
            return {
                text: true,
                required: {
                    higher_post: ['yes'],
                },
                name: `Post #${attr.substr(36)} Additional Height`,
            };
        }

        if (attr.substr(0, 29) === 'repeat_higher_post_increments') {
            return {
                price: true,
                qty: true,
                min: 0,
                max: 'number_of_higher_post_increments',
                empty_value_label: 'Same as All Posts',
                required: {
                    higher_post: ['yes'],
                },
                name: `Post #${attr.substr(30)} (6" increments)`,
            };
        }

        return this.buildSteps[structure].steps[stepId].attrs[attr];
    }

    /**
     * Get the number of posts including both base and additional posts.
     *
     * @returns {number} The number of posts including both base and additional posts.
     */
    getNumberOfTotalSelectedPosts() {
        const numOfPosts = this.getNumberOfPosts();
        const numOfAdditionalPosts = Number(
            this.getConfValue('additional_posts')
        );
        const numOfTotalPosts = numOfPosts + numOfAdditionalPosts;

        return numOfTotalPosts;
    }

    /**
     * Get the number of posts for the current configuration.
     */
    getNumberOfPosts() {
        return this.conf.number_of_posts;
    }

    /**
     * Get the number of benches for the current configuration.
     */
    getNumberOfBenches() {
        const numOfPosts = this.getNumberOfPosts();

        return numOfPosts + this.conf.bench_offset;
    }

    /**
     * Get the number of outlets for the current configuration.
     */
    getNumberOfOutlets() {
        const numOfPosts = this.getNumberOfPosts();

        return numOfPosts - 1;
    }

    /**
     * Get the number of additional posts for the current configuration.
     */
    getNumberOfAdditionalPosts() {
        const numOfPosts = this.getNumberOfPosts();

        return numOfPosts + 10;
    }

    /**
     * Get the number of higher post increments for the current configuration.
     */
    getNumberOfHigherPostIncrements() {
        return 8;
    }

    /**
     * Get the number of extra screen doors for the current configuration.
     */
    getNumberOfExtraScreenDoors() {
        const numOfPosts = this.getNumberOfPosts();

        return numOfPosts + 10;
    }

    /**
     * Get the number of privacy panels for the current configuration.
     */
    getNumberOfPrivacyPanels() {
        const numOfPosts = this.getNumberOfPosts();

        return numOfPosts + 10;
    }

    /**
     * Find out whether or not setting the specified attribute to
     * the specified option will result in a valid configuration.
     */
    confExists(attr, option, attr2, option2, attr3, option3) {
        const thisConf = Object.assign({}, this.o.conf);
        if (typeof attr !== 'undefined') {
            thisConf[attr] = option;
        }
        if (typeof attr2 !== 'undefined') {
            thisConf[attr2] = option2;
        }
        if (typeof attr3 !== 'undefined') {
            thisConf[attr3] = option3;
        }
        const confId = `${thisConf.structure}--${thisConf.style}--${thisConf.material}--${thisConf.size}`;

        // Make sure the build configuration exists.
        if (typeof this.buildOptions[confId] === 'undefined') {
            return false;
        }

        return true;
    }

    /**
     * Get the base price for the a configuration if the specified
     * attribute and option were to replace the current configuration's
     * value for the same attribute.
     */
    getOptionBasePrice(attr, option) {
        const thisConf = Object.assign({}, this.o.conf);
        thisConf[attr] = option;
        const confId = `${thisConf.structure}--${thisConf.style}--${thisConf.material}--${thisConf.size}`;

        // Make sure the build configuration exists.
        if (typeof this.buildOptions[confId] === 'undefined') {
            return 0;
        }

        let price = this.buildOptions[confId].base_price;

        price = this.markup(thisConf.structure, 'base', 'base', 'base', price);

        return price;
    }

    /**
     * Get the number of posts for the a configuration if the specified
     * attribute and option were to replace the current configuration's
     * value for the same attribute.
     */
    getOptionNumberOfPosts(attr, option) {
        const thisConf = Object.assign({}, this.o.conf);
        thisConf[attr] = option;
        const confId = `${thisConf.structure}--${thisConf.style}--${thisConf.material}--${thisConf.size}`;

        // Make sure the build configuration exists.
        if (typeof this.buildOptions[confId] === 'undefined') {
            return 0;
        }

        return this.buildOptions[confId].number_of_posts;
    }

    scrollToTop() {
        let topOffset;
        let el;

        if ($('.gb-mobile-menu').is(':visible')) {
            el = $('.gb-mobile-menu-select');
        } else {
            el = $('.gb-option-tabs');
        }

        topOffset = el.offset().top - 2;
        topOffset -= this.o.topOffset;
        $(document).scrollTop(topOffset);
    }

    changeSize() {
        const sizes = this.o.conf.size.replace('ft', '').split('x');
        $(`#gb-unit-size-width-option-${sizes[0]}`).prop('checked', true);
        if (sizes.length > 1) {
            $(`#gb-unit-size-height-option-${sizes[0]}-${sizes[1]}`).prop(
                'checked',
                true
            );
        }
    }

    refreshWidthLength() {
        const width = $('.gb-size-width-selector > input:checked').val();
        const height = $('.gb-size-height-selector > input:checked').val();

        // Show relevant height fields.
        $('.gb-size-height-selector').hide();
        $(`.gb-size-selector-choosen-width-${width}`).show();

        // Check relevant height field.
        $('.gb-size-height-selector input').prop('checked', false);
        let selectedHeight = $(
            `#gb-unit-size-height-option-${width}-${height}`
        );
        if (selectedHeight.length === 0) {
            selectedHeight = $(`.gb-size-selector-choosen-width-${width}`)
                .first()
                .children('input');
        }
        selectedHeight.prop('checked', true);
    }

    /**
     * Update the image src with one based on the current configuration.
     */
    refreshImg() {
        const src = this.getImgSrc();

        // Check if the image is already cached and
        // use it if it is.
        this.imgObj = new Image();
        this.imgObj.src = src;
        if (this.imgObj.complete === true) {
            // console.log('in cache');
            // console.log('in cache: loaded');
            this.changeImgSrc();
        } else {
            // console.log('load new');
            // Show a loading image.
            this.loadingImg.show();

            // Wait until the new image is downloaded
            // before hiding the loading image and changing
            // the main image's src.
            this.imgObj = new Image();
            this.imgObj.onload = () => {
                // console.log('load new: loaded');
                this.changeImgSrc();
            };

            // Initiate the download of the new image.
            this.imgObj.src = src;
        }
    }

    /**
     * Hide the loading image and change the image
     * src to the current config's image.
     */
    changeImgSrc() {
        const url = this.getImgSrc();

        this.loadingImg.hide();
        this.img.prop('src', url);

        $('input[name="conf_img_url"]').val(url);
    }

    getUrlConf() {
        const keys = [];

        for (const k in this.o.conf) {
            keys.push(k);
        }

        keys.sort();

        const len = keys.length;

        let src = '';
        for (let i = 0; i < len; i++) {
            const k = keys[i];
            src += `${k}-${this.o.conf[k]}--`;
        }
        src = src.substring(0, src.length - 2);

        return src;
    }

    getImgSrc() {
        const confUrl = this.getUrlConf();

        return `${this.o.urlBase}/builder/img/${confUrl}.${this.o.renderVersion}.jpg`;
    }

    getPgUrl() {
        const urlConf = this.getUrlConf();

        const url = window.location.href.split('?', 2);

        const pgUrl = `${url[0]}?gb-conf=${urlConf}#gb-step-${this.stepId}`;

        return pgUrl;
    }

    replaceHistoryState() {
        const url = this.getPgUrl();

        // if (!this.o.integrated && window.history.replaceState) {
        if (window.history.replaceState) {
            window.history.replaceState(
                { gazebo_builder: 1 },
                'Gazebo Builder',
                url
            );
        }

        const confJson = JSON.stringify(this.o.conf);
        $('input[name="conf_json"]').val(confJson);
        $('input[name="conf_url"]').val(url);
        $('input[name="form_ctrl[on_error]"]').val(url);
    }

    /* eslint-disable id-length, no-param-reassign */
    /**
     * Format a number as currency.
     */
    frmtMoney(n, c, d, t) {
        let j;

        c = isNaN((c = Math.abs(c))) ? 2 : c;
        const s = n < 0 ? '-' : '';
        const i = `${parseInt((n = Math.abs(Number(n) || 0).toFixed(c)), 10)}`;
        j = (j = i.length) > 3 ? j % 3 : 0;

        return (
            s +
            (j ? i.substr(0, j) + t : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/gu, `$1${t}`) +
            (c
                ? d +
                  Math.abs(n - i)
                      .toFixed(c)
                      .slice(2)
                : '')
        );
    }
    /* eslint-enable id-length, no-param-reassign */

    summaryPriceCalc() {
        let totalPrice = this.getBasePrice();

        const attrPrices = {
            base: totalPrice,
        };

        let attr;
        let val;

        const getPrices = (index, element) => {
            let price = 0;
            const stepId = $(element).data('stepid');

            const attrs = this.getAttrConf(this.o.conf.structure, stepId, attr);
            if (typeof attrs.qty !== 'undefined' && attrs.qty === true) {
                $(element).html(val);

                if (attr === 'higher_post_increments') {
                    const numOfTotalPosts = this.getNumberOfTotalSelectedPosts();

                    // Store the total price of all higher posts combined.
                    let priceTotalForAllHigherPosts = 0;

                    // The value of the "All Posts" increment selection.
                    // This is used for all posts unless a post has a specific
                    // override.
                    const baseNumOfIncrementsForPost = this.getConfValue(
                        'higher_post_increments'
                    );
                    // console.log(baseNumOfIncrementsForPost);

                    // Get the price of each post individually.
                    for (let i = 1; i <= numOfTotalPosts; i++) {
                        // This value can be set to override the number of
                        // increments for an specifc post.
                        const overriddenNumOfIncrementsForPost = this.getConfValue(
                            `repeat_higher_post_increments_${i}`
                        );

                        // Determine whether or not to use the base number of
                        // increments or an overridden number if specified.
                        //
                        // The value 999999235234 is used as a key for a number
                        // that should be treated as 0.
                        const numOfIncrementsForPost =
                            overriddenNumOfIncrementsForPost != '9923949234'
                                ? overriddenNumOfIncrementsForPost
                                : baseNumOfIncrementsForPost;

                        // console.log(overriddenNumOfIncrementsForPost);
                        // console.log(baseNumOfIncrementsForPost);
                        // console.log(numOfIncrementsForPost);

                        // Create a variable to hold the post price tier.
                        let higherPostsCost = 0;

                        for (let j = 1; j <= numOfIncrementsForPost; j++) {
                            const tierCost = this.getBaseOptionPrice(
                                `higher_post_increments_cost_${j}`,
                                ''
                            );

                            higherPostsCost += tierCost;
                        }

                        // For legeacy reasons the post tier is a value that
                        // represents all posts together. So the value needs
                        // divided by the number of posts so that it for one post.
                        let higherPostCostPerPost =
                            higherPostsCost / numOfTotalPosts;

                        // Mark up the value of the higher post.
                        higherPostCostPerPost = this.markup(
                            this.o.conf.structure,
                            'accessories',
                            attr,
                            this.o.conf[attr],
                            higherPostCostPerPost
                        );

                        // console.log(higherPostCostPerPost);

                        priceTotalForAllHigherPosts += higherPostCostPerPost;
                    }

                    // console.log(priceTotalForAllHigherPosts);
                    // console.log('--------------------------------');

                    price += priceTotalForAllHigherPosts;
                } else {
                    price = this.getOptionPrice(attr) * this.o.conf[attr];
                }

                // Move engineers seal and kit setup prices out of the
                // main subtotal and into the post discount subtotal.
                if (
                    attr !== 'engineers_seal_price' &&
                    attr !== 'kit_setup_extra_attach_to_house'
                ) {
                    totalPrice += price;
                }

                attrPrices[attr] = price;
            } else if (typeof attrs.options !== 'undefined') {
                const label = this.getOptionName(attrs, val);
                $(element).html(label);

                price = this.getOptionPrice(attr, this.o.conf[attr]);

                // Move engineers seal and kit setup prices out of the
                // main subtotal and into the post discount subtotal.
                if (
                    attr !== 'engineers_seal_price' &&
                    attr !== 'kit_setup_extra_attach_to_house'
                ) {
                    totalPrice += price;
                }

                attrPrices[attr] = price;
            }
        };

        for (attr in this.o.conf) {
            val = this.getConfValue(attr);

            $(`#gb-summary-attr-${attr} .gb-summary-attr-value`).each(
                getPrices
            );
        }

        // If kit_setup is set to 'yes' calculate based on it's value.
        if (
            typeof this.o.conf.kit_setup !== 'undefined' &&
            this.o.conf.kit_setup === 'yes' &&
            typeof this.buildOptions[this.confId].kit_setup__yes !== 'undefined'
        ) {
            const kitSetupPercentage = Number(
                this.getConfValue('kit_setup_percentage')
            );

            attrPrices.kit_setup = totalPrice * (kitSetupPercentage / 100);
            // totalPrice += attrPrices.kit_setup;
        }

        const attrPricesJson = JSON.stringify(attrPrices);
        $('input[name="estimate_json"]').val(attrPricesJson);

        $('input[name="estimate"]').val(totalPrice);
        const priceStrMoney = this.frmtMoney(totalPrice, 2, '.', ',');
        const priceStr = `$${priceStrMoney}`;
        this.estimate.html(priceStr);

        // Hide the estimate if prices are disabled.
        if (parseInt(this.o.userProfile.show_prices, 10) === 0) {
            this.estimateContainer.css('visibility', 'hidden');
        }
    }

    refreshSummary() {
        this.summaryPriceCalc();
    }
}
